// src/providers/AppAuthProviders.js
import React from "react";
import { AuthProvider } from "../features/Auth/AuthProvider";
import { AuthModalProvider } from "../features/Auth/useAuthModal";

export default function AppAuthProviders({ children }) {
  return (
    <AuthProvider>
      <AuthModalProvider>
        {children}
      </AuthModalProvider>
    </AuthProvider>
  );
}
